import { RESERVE_SUCCESSFUL, GO_BACK, REVIEW_TICKET, REMOVE_TICKET, RESERVE_TICKET, SET_BUYER, SET_BUYER_PASSENGERS, SET_ISSUE, SET_PASSENGERS, SET_PAYMENT, SET_TICKET, TICKET_PRICE, RESERVED_TICKET } from "../actions/ticket";


/*const passengerModel=  {
    nationalId:null,
    passportId:null,
    passportExpire:null,
    DocType:null,//Passport = 1,NationalId = 4,
    DocIssuedCountry:null,//country iso code
    name:null,
    family:null,
    BirthDate:null,
    Gender:null,//Male = 1,Female = 2
    PassengerType:null,//Adult = 1, Child = 2, Infant = 3
    id:null
};*/
/*const ticketModel= {
    ticketNbr:null,
    passengerId:null,
};*/

const initialState = {
    rph: null,
    adultNo: 1,
    childNo: 0,
    infantNo: 0,
    orgTicket: null,
    ticket: {
        isDomestic: false,
        departureAirport: null,
        arrivalAirport: null,
        departureDate: null,
        arrivalDate: null,
        airLine: null,
        bookingClassAvail: "Economy",
        airEquipType: null,
        airEquipName: null,
        flightNumber: null,
        flightDuration: null,
        isChartered: false,
        isRefundable: false,
        availableSeat: 0,
        airItineraryRph: null,
        baseFare: 0,
        totalFare: 0,
        adultFare: 0,
        adultFareT: 0,
        childFare: 0,
        childFareT: 0,
        infantFare: 0,
        infantFareT: 0,
    },
    passengers: [],
    buyer: {
        phone: null,
        tel: null,
        email: null,
        country: null,
        state: null,
        city: null,
        address: null,
        poCode: null
    },
    payment: {
        price: 0,
        discount: 0,
        totalPrice: 0,
        couponCode: null,
        //
        payDate: null,
        refNumber: null,
        payToken: null,
        payType: null,
        payStatus: null,
    },
    bookingRef: {
        issue: null,
        type: 'Reservation',
        isSuccessful: true,
        errors: [],
    },
    tickets: [

    ]
};

export default function ticket(state = initialState, action = {}) {
    switch (action.type) {
        case SET_TICKET:
            //set  rph,orgTicket,ticket,adultNo,childNo,infantNo
            const { orgTicket, ticket, adultNo, childNo, infantNo } = action;
            return {
                ...state,
                rph: ticket.airItineraryRph,
                adultNo,
                childNo,
                infantNo,
                orgTicket,
                ticket,
            };

        case REVIEW_TICKET:
            const { data, rev_passengers } = action;
            return {
                ...state,
                review_ticket: {
                    data: data,
                    rev_passengers: rev_passengers
                }
            };
        case GO_BACK:
            const { goback } = action;
            return {
                ...state,
                goback: {
                    goback: goback
                }
            };
        case RESERVED_TICKET:
            const { reserve } = action;
            return {
                ...state,
                reserved_ticket: {
                    reserve
                }
            };
        case RESERVE_SUCCESSFUL:
            const { id } = action;
            return {
                ...state,
                reserve_successful: {
                    id
                }
            };
        case SET_BUYER:
            //set  current user info
            const { buyer } = action;
            return {
                ...state,
                buyer
            };
        case SET_PASSENGERS:
            //set passenger
            const { passengers } = action;
            return {
                ...state,
                passengers
            };
        case SET_BUYER_PASSENGERS:
            //set  current user info and passenger
            const { user, traveller } = action;
            return {
                ...state,
                passengers: traveller,
                buyer: user
            };
        case TICKET_PRICE:
            //set and calculate price - discount
            const { priceObj } = action;
            return {
                ...state,
                payment: {
                    ...state.payment,
                    price: priceObj.price,
                    discount: priceObj.discount,
                    totalPrice: priceObj.totalPrice,
                    couponCode: priceObj.couponCode,
                },
            };
        case RESERVE_TICKET:
            //reserve ticket for payment -  first verify then reserve
            const { bookObj } = action;
            return {
                ...state,
                bookingRef: bookObj
            };
        case SET_ISSUE:
            //verify ticket
            const { tickets } = action;
            return {
                ...state,
                tickets
            };
        case SET_PAYMENT:
            //verify ticket
            const { paymentObj } = action;
            return {
                ...state,
                payment: {
                    ...state.payment,
                    payDate: paymentObj.payDate,
                    refNumber: paymentObj.refNumber,
                    payToken: paymentObj.payToken,
                    payType: paymentObj.payType,
                    payStatus: paymentObj.payStatus,
                }
            };
        case REMOVE_TICKET:
            //remove ticket
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/ticketReducer.js